import { cn } from "@/lib/utils";
import Lottie from "lottie-react";

import emptyAnimation from "@/assets/lottieAnimations/Competitors Ads.json";
import { SqButton } from "@/components/squircle-ui/button";
import { RiAddLargeLine } from "@remixicon/react";

type Props = {
  className?: string;
  onAddBrand: () => void;
};

const NoCompetitors = ({ className, onAddBrand }: Props) => {
  return (
    <div
      className={cn("w-full h-full flex flex-col items-center justify-center", className)}
    >
      <div className="w-[300px]">
        <Lottie
          animationData={emptyAnimation}
          loop={true}
          autoplay={true}
          style={{ width: "100%", height: "100%", mixBlendMode: "darken" }}
        />
      </div>
      <div className="mt-[12px] text-[12px] font-medium text-brand-primary-800">
        Who are you watching?
      </div>
      <div className="text-[12px] text-brand-primary-600">
        Add a brand to monitor ads, launches, and creative changes.
      </div>
      <div className="mt-4">
        <SqButton size={"sm"} variant={"outline"} onClick={onAddBrand}>
          <RiAddLargeLine size={14} className="text-brand-primary-400" />
          <span className="text-brand-primary-800">Add Brand</span>
        </SqButton>
      </div>
    </div>
  );
};

export default NoCompetitors;
